
<div class="container blocked-org">
  <img style="height: 55vh;" src="../../../../assets/icons/Organization Blocked 1.svg">
<h4 *ngIf="authService.showPermissionContent===true">Permission Denied</h4>
<h6 *ngIf="authService.showPermissionContent===true"> You do not have required permissions, kindly contact admin of your organization.</h6>
  <h4 *ngIf="authService.showPermissionContent===false">Organization {{ authService.loggedInUser.bill?.status | titlecase }}</h4>
  <h6 *ngIf="authService.showPermissionContent===false">You currently do not have access to this page.</h6>
</div>